import React from "react";
import { Params, Route, Routes } from "react-router-dom";
import {
  DashboardTopBar,
  DashboardTopRightSide,
  ItemContentArea,
} from "../../../shared/components";
import { observer } from "mobx-react";
import InvoiceGrid from "./InvoiceGrid";
import InvoiceDetailMain from "./InvoiceDetailMain";
import { UtilityMethods, withRouter } from "@mindmemobile/mm-shared-global";
import {
  InvoiceStore,
  ItemsStore,
  RolesAndPermissionStore,
} from "../../../shared/store";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

type IProps = {
  invoiceStore: InvoiceStore;
  itemStore: ItemsStore;
  params: Readonly<Params<string>>;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
};

const InvoiceRoutes: React.FC<IProps> = ({
  itemStore,
  invoiceStore,
  params,
  rolesAndPermissionStore,
  merchantAccountStore,
}) => {
  function invoiceId() {
    const split = ((params && params["*"]) || "").split("/");
    const id = split[split.length - 1];
    if (UtilityMethods.isValidObjectId(id)) {
      return id;
    }
    return null;
  }

  return (
    <Routes>
      <Route
        path={`/`}
        element={
          <InvoiceGrid
            invoiceStore={invoiceStore}
            itemStore={itemStore}
            rolesAndPermissionStore={rolesAndPermissionStore}
            merchantAccountStore={merchantAccountStore}
          />
        }
      />
      <Route
        path={`/detail/:id`}
        element={
          <InvoiceDetailMain
            itemStore={itemStore}
            invoiceId={invoiceId() || ""}
            invoiceStore={invoiceStore}
            rolesAndPermissionStore={rolesAndPermissionStore}
            merchantAccountStore={merchantAccountStore}
          />
        }
      />
    </Routes>
  );
};
export default withRouter(observer(InvoiceRoutes));
